import * as React from 'react'
import * as css from './Marker.module.css'
import { MapContext } from './MapContext'
import MarkerIcon from 'components/map/MarkerIcon'
import clsx from 'clsx'

const Marker = ({ lat, lng, type, company, description, _id }) => {
	const { $center, set$center, set$zoom, checkIfOB } =
		React.useContext(MapContext)

	function onClick() {
		set$center({ lat, lng })
		set$zoom(14)
	}

	React.useEffect(() => {
		if (!typeof document === 'undefined') return

		const label = document.querySelector(`label[for="input-${_id}"]`)
		if (checkIfOB({ lat, lng })) {
			label?.classList.add('is-ob')
		} else {
			label?.classList.remove('is-ob')
		}
	}, [$center, _id, lat, lng, checkIfOB])

	return (
		<div className="group relative z-[1] hover:z-10 has-[input:hover]:z-10">
			<div className="ml-6 flex transition-all">
				<input id={`input-${_id}`} name="project" type="radio" hidden />

				<MarkerIcon
					id={`marker-${_id}`}
					className={clsx(
						'-ml-6 text-lg',
						'group-hover:!bg-white group-hover:text-[var(--color)]',
						'group-has-[input:hover]:scale-125 group-has-[input:hover]:!bg-white group-has-[input:hover]:!text-[var(--color)]',
					)}
					type={type?.[0]}
					onClick={onClick}
				/>
			</div>

			<div className="absolute -right-12 bottom-full z-[1] hidden translate-x-4 translate-y-4 group-hover:block group-has-[input:hover]:block">
				<div
					className={clsx(
						css.details,
						'anim-fadein mb-8 w-[300px] bg-white px-3 py-2 font-sans text-ink shadow-lg',
					)}
				>
					<div className="flex items-center gap-2">
						<MarkerIcon
							className="text-3xl shadow-none"
							type={type?.[0]}
							onClick={onClick}
						/>
						<dl className="text-base leading-tight">
							<dt className="h5 mb-1">{description}</dt>
							<dd>{company}</dd>
						</dl>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Marker
